export default __webpack_public_path__ + "static/media/MadeUp_02.fb0b4ae9.png";